import NotFound from "../components/NotFoundPage";
import { Navigate } from "react-router";
import Home from "../pages/Home";
import Login from "../pages/Login";
import SignUp from './../pages/SignUp';
import ForgotPassword from "../pages/ForgotPassword";
import SelfSignUp from "../pages/selfSignUp/SelfSignUp";
import ShowInterest from "../pages/ShowInterest";

// export const rootUserMenu = (userType) => {
//   return [
//     ...userType === "admin" ? {
//       path: "adminScreen",
//       element: <>Admin Screen </>
//     } :
//     {
//       path: "userScreen",
//       element: <>User Screen </>
//     }
//   ];
// };

export const routeData = (auth, userType) => {
  return [

    {
      path: "/",
      element: auth ? <Home /> : <Navigate to="/login" />,
      nestedRoutes: [],
    },
    {
      path: "/login",
      element: auth ? <Navigate to="/" /> : <Login />,
    },
    {
      path: "/forgot-password",
      element: auth ? <Navigate to="/" /> : <ForgotPassword />,
    },
    {
      path: "/signup",
      element: auth ? <Navigate to="/" /> : <SignUp />,
    },
    {
      path: "/self-signup",
      element: auth ? <Navigate to="/" /> : <SelfSignUp />,
    },
    {
      path: "/showInterest",
      element: auth ? <Navigate to="/" /> : <ShowInterest />,
    },
    {
      path: "/health",
      element: <></>,
    },
    {
      path: "*", // Catch All Invalid Routes
      element: <NotFound />,
    },
  ];
};